import React, { useMemo } from 'react';

import { GroupSelector } from './GroupSelector';
import './styles.scss';
import { RECENT_GROUP_ID, ROOT_GROUP_ID } from '../../../../constants/group';
import { CUSTOM_GROUP_ID } from '../constant';
import { GroupCameras } from './GroupCameras';
import { AllCameras } from './AllCameras';

const allOption = {
  label: 'All',
  value: ROOT_GROUP_ID,
};

const pinnedOption = {
  label: 'Pinned',
  value: RECENT_GROUP_ID,
};

const customOption = {
  label: 'Custom',
  value: CUSTOM_GROUP_ID,
};

export const ListCamera = ({
  getIsCameraPinned,
  onPinCamera,
  namespace,
  selectedGroup,
  onSelectGroup,
  cameras,
  currentPage,
  pageSize,
  total,
  onPageChange,
  isLoading,
  selectedSerial,
  onSelectCamera,
  onSearch,
}) => {
  const selectedGroupId = selectedGroup?.id;
  const additionalOptions = useMemo(() => {
    if (!selectedGroup) {
      return [pinnedOption, allOption];
    }

    if (selectedGroup.id === CUSTOM_GROUP_ID) {
      return [customOption, pinnedOption, allOption];
    }

    return [
      {
        label: selectedGroup.name,
        value: selectedGroup.id,
      },
      pinnedOption,
      allOption,
    ];
  }, [selectedGroup]);

  return (
    <div className="live-list-camera">
      <GroupSelector
        namespace={namespace}
        additionalOptions={additionalOptions}
        selectedId={selectedGroupId}
        onSelect={onSelectGroup}
      />
      {selectedGroupId !== ROOT_GROUP_ID &&
        selectedGroupId !== RECENT_GROUP_ID && (
          <GroupCameras
            cameras={cameras}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={onPageChange}
            isLoading={isLoading}
            getIsCameraPinned={getIsCameraPinned}
            onPinCamera={onPinCamera}
            total={total}
            selectedSerial={selectedSerial}
            onSelectCamera={onSelectCamera}
          />
        )}
      {(selectedGroupId === ROOT_GROUP_ID ||
        selectedGroupId === RECENT_GROUP_ID) && (
        <AllCameras
          namespace={namespace}
          onSelectCamera={onSelectCamera}
          cameras={cameras}
          currentPage={currentPage}
          pageSize={pageSize}
          total={total}
          onPageChange={onPageChange}
          isLoading={isLoading}
          selectedSerial={selectedSerial}
          getIsCameraPinned={getIsCameraPinned}
          onPinCamera={onPinCamera}
          onSearch={onSearch}
        />
      )}
    </div>
  );
};
